import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // ✅ correct import

const isTokenValid = () => {
  const token = localStorage.getItem("admin_token");
  console.log(token)

  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    console.log("Decoded:", decoded);
    return decoded.exp > Date.now() / 1000;
  } catch (err) {
    console.error("JWT decode error:", err);
    return false;
  }
};

const PrivateRouteAdmin = () => {
  return isTokenValid() ? <Outlet /> : <Navigate to="/login_admin" replace />;
};

export default PrivateRouteAdmin;
